import { Link } from 'react-router-dom';
import { Modal, Input, Select } from 'antd';

import { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { commas } from '../../methods/utils/general-utils';
import { useAppDispatch } from '../../methods/redux/hooks';
import { startWithdrawal } from '../../methods/redux/reducers/investment';

const InvestmentProfileStyle = styled.div`
	padding: 15px;
	background-color: #f8f8f8;
	margin-bottom: 10px;

	& .title {
		font-size: 18px;
		text-transform: capitalize;
	}

	& .details {
		display: flex;
		flex-wrap: wrap;
		justify-items: space-between;
		align-items: flex-end;
		border-top: 1px dashed #ccc;
		margin-top: 10px;

		& > * {
			min-width: 100px;
			margin-right: 15px;
			padding: 5px 0;
			font-size: 13px;

			& .label {
				color: #bbb;
				font-size: 12px;
			}
		}
	}
`;

interface UserProfile {
	_id: string;
	username: string;
}

interface WithdrawalList {
	_id: string;
	userId: UserProfile | null;
	investmentForm: string;
	riseVestTransactionId: string;
	amount: string;
	createdAt: string;
	status: string;
	liquidate: boolean;
	proxyStaffId: any;
	withdrawalStatus: number;
	updatedAt: string;
}

interface IWithdrawal {
	list: WithdrawalList;
}

const InvestmentWithdrawalList = ({ list }: IWithdrawal) => {
	const dispatch = useAppDispatch();

	const [state, setState] = useState({
		amount: 0,
		memberId: list?.userId?._id,
		investmentId: list?._id,
		validationCode: '',
		liquidate: false,
	});

	const liquidateEnum = [
		{
			key: 'true',
			label: 'true',
		},
		{
			key: 'false',
			label: 'false',
		},
	];
	const [visible, setVisible] = useState(false);

	const submit = () => {
		dispatch(startWithdrawal({ ...state }));
		// setState({ bvn: '', memberId: '' });
		// window.location.reload();
		setVisible(false);
	};

	function checkIfObject(data: any) {
		if (Array.isArray(data)) {
			return true;
		}
		if (typeof data === 'object' && data !== null) {
			return true;
		}
		if (typeof data === 'string') {
			return false;
		}
		return false;
	}

	// Examples
	console.info(checkIfObject(['a', 'b'])); // Output: Array
	console.info(checkIfObject({ key: 'value' })); // Output: Object
	console.info(checkIfObject('text')); // Output: String

	// Examples
	console.info(checkIfObject(['a', 'b'])); // Output: Array
	console.info(checkIfObject({ key: 'value' })); // Output: Object
	console.info(checkIfObject('text')); // Output: String

	return (
		<InvestmentProfileStyle>
			<div
				style={{
					display: 'flex',
				}}
			>
				<Link
					to={`/core-modules/investment/withdrawals/single?investmentWithdrawalId=${
						list?._id || ''
					}`}
					className="title"
				>
					{list?.investmentForm || 'Untitled'}
				</Link>
			</div>
			<div className="details">
				<div>
					{checkIfObject(list?.userId) ? (
						<Link to={`/user-profile/${list?.userId?._id}`}>
							@{list?.userId?.username || 'Unknown'}
						</Link>
					) : (
						<Link to={`/user-profile/${list?.userId}`}>
							@{list?.userId || 'Unknown'}
						</Link>
					)}
					<p className="label">UserName</p>
				</div>

				<div>
					{checkIfObject(list?.proxyStaffId) ? (
						<Link to={`/user-profile/${list?.proxyStaffId?._id}`}>
							@{list?.proxyStaffId?._id || 'Unknown'}
						</Link>
					) : (
						<Link to={`/user-profile/${list?.proxyStaffId}`}>
							@{list?.proxyStaffId || 'Unknown'}
						</Link>
					)}

					<p className="label">Proxy Staff Id</p>
				</div>

				<div>
					<p>{list?.status || 'N/A'}</p>
					<p className="label">Status</p>
				</div>
				<div>
					<p>{list?.withdrawalStatus || 'N/A'}</p>
					<p className="label">Withdrawal Status</p>
				</div>
				<div>
					<p>{list?.liquidate && list?.liquidate ? 'True' : 'false'}</p>
					<p className="label">Liquidate</p>
				</div>
				<div>
					<p>{list?.riseVestTransactionId || 'N/A'}</p>
					<p className="label">RiseVestTransactionId</p>
				</div>
				<div>
					<p>{commas(list?.amount || 0)} </p>
					<p className="label">Amount</p>
				</div>

				<div>
					<p>
						{list?.createdAt
							? moment(list.createdAt).format('MMM D, YY / hh:mm:ss a')
							: 'N/A'}
					</p>
					<p className="label">Created Date</p>
				</div>

				<div>
					<p>
						{list?.updatedAt
							? moment(list.updatedAt).format('MMM D, YY / hh:mm:ss a')
							: 'N/A'}
					</p>
					<p className="label">Updated At</p>
				</div>
			</div>
			<Modal
				okText="Withdraw from Investment"
				title="Withdraw from Investment"
				onOk={submit}
				visible={visible}
				onCancel={() => setVisible(false)}
			>
				<p>Validation Code</p>
				<Input
					value={state.validationCode}
					onChange={(e) =>
						setState({ ...state, validationCode: e.target.value })
					}
				/>
				<p>Amount</p>
				<Input
					value={state.amount}
					onChange={(e) =>
						setState({ ...state, amount: Number(e.target.value) })
					}
				/>
				<p>Liquidate</p>
				<Select
					defaultValue={state.liquidate}
					style={{ width: '100%' }}
					onChange={(value) =>
						setState({
							...state,
							liquidate: Boolean(value),
						})
					}
				>
					{liquidateEnum.map((i: any) => (
						<Select.Option key={i.key} value={i.key}>
							{i.label}
						</Select.Option>
					))}
				</Select>
			</Modal>
		</InvestmentProfileStyle>
	);
};
export default InvestmentWithdrawalList;
